
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy/[locale]",
      function () {
        return require("private-next-pages/privacy-policy/[locale]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy/[locale]"])
      });
    }
  